/*
 * Built with Common Launchpad 2.0.3
 */

import { getField, updateField } from 'vuex-map-fields';
import wqt from '../../api/wqt';

// initial state
const state = {
	currentStep: 0,
	concurrentGuid: '',
	concurrentPostalCode: '',
	resource: 'submitqualifiertool',
	qtResponse: [],
	qualifierToolRequest: {},
	formData: {},
	isLoading: false,
	hasSubmissionError: false,
};

// getters
const getters = {
	getField,
};

// actions
const actions = {
	updateStep({ commit, rootState }, step) {
		commit('setStep', step);
	},
	postData({ commit, rootState }, data) {
		// call the api with update specification object
		commit('setQualifierToolRequest', data);		
		wqt.postData(x => {
			const failedWebServiceSubmit = data.SubmitToWebService && x && x.WebServiceSubmitStatus === false && x.IsDuplicate !== true;
			if ((x && x.IsError) || failedWebServiceSubmit) {
				commit('setQTErrorResponse', x);
				// eslint-disable-next-line no-console
				console.error('[WQT] Qualifier tool submission failed.', {
					step: data.QualifierToolToSubmitModel && data.QualifierToolToSubmitModel.FormStep,
					submissionId: data.SubmittedQualifierToolGuid || x.QualifierToolSubmittedGuid || null,
					resource: state.resource,
					httpStatus: x.HttpStatus || null,
					httpStatusText: x.HttpStatusText || null,
					errorCode: x.ErrorCode || null,
					webServiceSubmitStatus: x.WebServiceSubmitStatus,
					message: x.WebServiceResponseMessage || 'No error details were returned.'
				});
				return;
			}

			commit('setQTResponse', x);
		}, { data, resource: state.resource });
	},
};

// mutations
const mutations = {
	initData(state, data) {
		state.formData = data;
		mutations.clearSubmissionData(state);
	},
	setStep(state, step) {
		state.currentStep = step;
		state.isLoading = false;		
		state.hasSubmissionError = false;

		if (step > 11) {
			mutations.clearSubmissionData(state);
		}
	},
	clearSubmissionData(state) {
		state.concurrentGuid = '';
		state.concurrentPostalCode = '';
		state.hasSubmissionError = false;
	},
	setQualifierToolRequest(state, data) {
		state.qualifierToolRequest = data;		
		state.hasSubmissionError = false;
		if (data.IsNewRequest) {
			state.concurrentPostalCode = data.QualifierToolToSubmitModel.PostalCode;
		}
	},
	setQTResponse(state, data) {
		state.qtResponse = data;		
		state.concurrentGuid = state.concurrentGuid || data.QualifierToolSubmittedGuid;
		state.hasSubmissionError = false;
	},
	setQTErrorResponse(state, data) {
		state.qtResponse = data;
		state.isLoading = false;
		state.hasSubmissionError = true;
	},
	setLoadingState(isLoading) {
		state.isLoading = isLoading;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
